import { Button } from "antd"
import { CheckOutlined, CloseOutlined, DeleteOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import styled from "styled-components";
import { ConfiguracionAnalitica } from "../useConfiguracionesAnaliticaApi";
import React, { createRef, useEffect, useRef, useState } from "react";

const ImageContainer = styled.div`
position:relative;
overflow:hidden;
`;

const Container = styled.div`

`;

const ActionsButton = styled.div`
display: grid;
grid-template-columns: repeat(auto-fit,minmax(40px,1fr));
gap:0.5rem;
& > *
{
    width:100%;
}
`;

const AreaButtons = styled.div`
display: grid;
//grid-template-columns: repeat(auto-fit,minmax(120px, 1fr));
grid-template-columns: repeat(4,1fr);
gap: 1rem;
& > div
{
    display: grid;
    grid-template-columns: 1fr auto;
}
`;

const ImageSvg = styled.svg`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
transition: all .3s;
`;

const ImageToolbar = styled.div`
background: #212121;
padding: 1rem;

& > span
{
    color: white;
    font-weight: 600;
    font-size: 1rem;
    margin-bottom: 0.5rem;
    display: block;
}
`;

const ZoomableImage = styled.img`
transition: transform .3s;
width:100%;
display:block;
user-select:none;
`;

const ButtonsContainer = styled.div`
display: grid;
grid-template-columns: 1fr auto;
gap: 1rem;
`;

const ColorGuide = styled.span`
width: 18px;
height: 18px;
margin-left: 0.5rem;
`;

export type AreaType = 'polygon'|'line'|'rectangle';

export interface AreaConfig {
    buttonText: string
    name: string
    color: string
    multiple?: boolean
    required?: boolean
    type:AreaType
}

export interface AreaInputProps {
    value?: AreaValue,
    onChange?: (value: AreaValue) => any
    areas: AreaConfig[]
    img: string
};

type AreaValue = { [key: string]: number[][][] };

export default (props: AreaInputProps) => {
    const [value, setValue] = useState<AreaValue>({});
    const [currentAreaName, setCurrentAreaNameName] = useState<string>();
    const [editingArea, setEditingArea] = useState<number[][]>([]);
    const [deleteMode, setDeleteMode] = useState(false);
    const [hiddenAreas, setHiddenAreas] = useState<string[]>([]);

    const [zoomLevel, setZoomLevel] = useState<number>(1);
    const [zoomOffset, setZoomOffset] = useState<{ x: number, y: number }>({ x: 0, y: 0 });
    const zoomFactor = useRef(0.5)
    const maxZoomLevel = useRef(30);
    const zoomableImageRef = createRef<HTMLImageElement>();
    const imageContainerRef = createRef<HTMLDivElement>();

    useEffect(() => {
        setValue(props.value ?? {});
    }, [props.value]);

    useEffect(() => {

        const onWindowWheel = (e: any) => {
            if (e.target?.classList?.contains("overlay") || e.target.tagName == 'svg' || e.target.parentElement?.tagName == 'svg') {
                e.preventDefault();
            }
        }
        window.addEventListener('wheel', onWindowWheel, { passive: false })

        return () => {
            window.removeEventListener('wheel', onWindowWheel);
        };

    }, []);

    const getCurrentArea = () => 
    {
        if(!currentAreaName) return;
        return props.areas.filter(a => a.name == currentAreaName)[0];
    }

    const addPoint = (coords: { x: number, y: number, imageX: number, imageY: number } | undefined) => {
        if (!coords) return;
        if (!currentAreaName) return;
        const newEditingArea:number[][] = JSON.parse(JSON.stringify(editingArea));
        newEditingArea.push([coords.imageX, coords.imageY]);
        setEditingArea(newEditingArea);
    };

    const deleteArea = (name: string, index: number) => {
        if (!deleteMode) return;
        const newValue = JSON.parse(JSON.stringify(value));
        newValue[name].splice(index, 1);
        setValue(newValue);
        props.onChange?.(newValue);
        //setDeleteMode(false);
    }

    const confirmArea = () => {
        if (!currentAreaName) return;
        const newValue = { ...value, ...{ [currentAreaName]: [...(value[currentAreaName] ?? []), ...[editingArea]] } };
        setValue(newValue);
        props.onChange?.(newValue);
        resetSelection();
    }

    const cancelArea = () => {
        resetSelection();
    }

    const resetSelection = () => {
        setEditingArea([]);
        setCurrentAreaNameName(undefined);
        setHiddenAreas([]);
    }

    const zoomImage = (e: React.WheelEvent<any>) => {

        let delta = Math.max(-1, Math.min(1, e.deltaY)) // cap the delta to [-1,1] for cross browser consistency
        delta = delta > 0 ? -delta : Math.abs(delta);

        let newZoomLevel = zoomLevel + delta * zoomFactor.current * zoomLevel;

        if (newZoomLevel > maxZoomLevel.current) {
            newZoomLevel = maxZoomLevel.current;
        }

        //const containerWidth = imageContainerRef.current!.getBoundingClientRect().width;
        //const containerHeight = imageContainerRef.current!.getBoundingClientRect().height;

        const zoomPointX = (e.pageX - imageContainerRef.current!.getBoundingClientRect().left - window.scrollX);
        const zoomPointY = (e.pageY - imageContainerRef.current!.getBoundingClientRect().top - window.scrollY);

        const zoomTargetX = ((zoomPointX - zoomOffset.x) / zoomLevel);
        const zoomTargetY = ((zoomPointY - zoomOffset.y) / zoomLevel);

        let zoomOffsetX = -zoomTargetX * newZoomLevel + zoomPointX;
        let zoomOffsetY = -zoomTargetY * newZoomLevel + zoomPointY;

        if (zoomOffsetX > 0) {
            zoomOffsetX = 0;
        }

        if (zoomOffsetY > 0) {
            zoomOffsetY = 0;
        }

        if (newZoomLevel < 1) {
            newZoomLevel = 1;
        }
        setZoomLevel(newZoomLevel)
        setZoomOffset({
            x: zoomOffsetX,
            y: zoomOffsetY
        })

        //const offsetX =

    };


    const getClickedCoords = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): { x: number, y: number, imageX: number, imageY: number } | undefined => {
        //@ts-ignore
        if (!e.target.clientWidth || !e.target.clientHeight) {
            return;
        }
        //@ts-ignore
        const x = e.nativeEvent.offsetX / e.target.clientWidth;
        //@ts-ignore
        const y = e.nativeEvent.offsetY / e.target.clientHeight;

        const imageRect = zoomableImageRef.current!.getBoundingClientRect();
        const imageX = Math.abs(e.clientX - imageRect.left) / imageRect.width;
        const imageY = Math.abs(e.clientY - imageRect.top) / imageRect.height;

        return { x, y, imageX, imageY }
    }

    return (
        <Container>
            <ImageContainer className="image-container" onWheel={zoomImage} ref={imageContainerRef} onClick={(e) => addPoint(getClickedCoords(e))}>

                <ZoomableImage
                    className="zoomable-image"
                    ref={zoomableImageRef}
                    style={{
                        transform: `translate(${zoomOffset.x}px,${zoomOffset.y}px) scale(${zoomLevel},${zoomLevel})`,
                        transformOrigin: '0 0'
                    }}
                    src={props.img} />
                <ImageSvg
                    style={{
                        transform: `translate(${zoomOffset.x}px,${zoomOffset.y}px) scale(${zoomLevel},${zoomLevel})`,
                        transformOrigin: '0 0'
                    }}
                    viewBox="0 0 100 100"
                    preserveAspectRatio="none">

{Object.keys(value).filter((k) => !hiddenAreas.includes(k)).map((k, index) => value[k].map((points, index2) =>
                        <>
                        {props.areas.filter(a => a.name == k).length == 1 && 
                            <>
                                {props.areas.filter(a => a.name == k)[0].type == 'polygon' &&
                                    <polygon
                                    onClick={() => deleteArea(k, index2)}
                                    fillOpacity={0.75}
                                    strokeWidth={0.15 / zoomLevel}
                                    stroke={'black'}
                                    style={{ cursor: deleteMode ? 'pointer' : 'default' }}
                                    fill={props.areas.filter(a => a.name == k)[0]!.color}
                                    key={`${k}-${index2}`}
                                    points={points.map(p => p.map(c => c * 100).join(",")).join(" ")} />
                                }

                                {(props.areas.filter(a => a.name == k)[0].type == 'line') && 
                                    <polyline
                                    onClick={() => deleteArea(k, index2)}
                                    fill="transparent"
                                    strokeWidth={0.8 / zoomLevel}
                                    stroke={props.areas.filter(a => a.name == k)[0]!.color}
                                    style={{ cursor: deleteMode ? 'pointer' : 'default' }}
                                    key={`${k}-${index2}`}
                                    points={points.map(p => p.map(c => c * 100).join(",")).join(" ")} />
                                }
                                {props.areas.filter(a => a.name == k)[0].type == 'rectangle' && 
                                    <rect
                                    key={`${k}-${index2}`}
                                    style={{ cursor: deleteMode ? 'pointer' : 'default' }}
                                    onClick={() => deleteArea(k, index2)}
                                    fill={props.areas.filter(a => a.name == k)[0]!.color}
                                    strokeWidth={0.15 / zoomLevel}
                                    stroke={'black'}
                                    x={points[0][0] < points[1][0] ? 
                                        points[0][0] * 100 : points[1][0] * 100}
                                    y={points[0][1] < points[1][1] ? 
                                        points[0][1] * 100 : points[1][1] * 100}
                                    width={Math.abs((points[1][0] * 100) - (points[0][0] * 100))}
                                    height={Math.abs((points[1][1] * 100) - (points[0][1] * 100))}
                                    />
                                }
                            </>
                        }</>
                        
                    ))}


                    {editingArea.length > 2 && getCurrentArea()?.type == 'polygon' &&
                        <polygon
                            fill="transparent"
                            stroke="red"
                            strokeWidth={0.25 / zoomLevel}
                            strokeDasharray={0.5 / zoomLevel}
                            points={editingArea.map(p => p.map(c => c * 100).join(",")).join(" ")} />}

                    {editingArea.length == 2 && getCurrentArea()?.type == 'rectangle' &&
                        <rect
                            fill="transparent"
                            stroke="red"
                            strokeWidth={0.25 / zoomLevel}
                            strokeDasharray={0.5 / zoomLevel}
                            x={editingArea[0][0] < editingArea[1][0] ? 
                                editingArea[0][0] * 100 : editingArea[1][0] * 100}
                            y={editingArea[0][1] < editingArea[1][1] ? 
                                editingArea[0][1] * 100 : editingArea[1][1] * 100}
                            width={Math.abs((editingArea[1][0] * 100) - (editingArea[0][0] * 100))}
                            height={Math.abs((editingArea[1][1] * 100) - (editingArea[0][1] * 100))}
                        />}

                    {(getCurrentArea()?.type == 'line'  ||
                        (getCurrentArea()?.type != 'rectangle' && editingArea.length == 2)
                    )&&
                        <polyline
                            fill="transparent"
                            stroke="red"
                            strokeWidth={0.25 / zoomLevel}
                            strokeDasharray={0.5 / zoomLevel}
                            points={editingArea.map(p => p.map(c => c * 100).join(",")).join(" ")} />}

                    {editingArea.length == 1 &&
                        <circle
                            r={0.5 / zoomLevel}
                            fill="red"
                            stroke="black"
                            strokeWidth={0.15 / zoomLevel}
                            cx={editingArea[0][0] * 100}
                            cy={editingArea[0][1] * 100} />}


                </ImageSvg>

                {currentAreaName &&
                    <div
                        className="overlay"
                        style={{
                            transform: `translate(${zoomOffset.x}px,${zoomOffset.y}px) scale(${zoomLevel},${zoomLevel})`,
                            transformOrigin: '0 0',
                            opacity: 0,
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%"
                        }}

                    />}
            </ImageContainer>
            <ImageToolbar>
                <span>Areas a marcar</span>
                <ButtonsContainer>
                    <AreaButtons>
                        {props.areas.map((area) =>
                            <div>
                                <Button style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} disabled={!(area.multiple || !value[area.name] || value[area.name].length == 0)} key={area.name} type={area.name == currentAreaName ? 'primary' : 'default'} onClick={() => { setDeleteMode(false); setCurrentAreaNameName(area.name); }}>{area.buttonText} <ColorGuide style={{ backgroundColor: area.color, opacity: 0.75, border: '1px solid black' }} /></Button>
                                {!hiddenAreas.includes(area.name) && <Button onClick={() => setHiddenAreas([...hiddenAreas, ...[area.name]])} type={'default'} icon={<EyeInvisibleOutlined />} />}
                                {hiddenAreas.includes(area.name) && <Button onClick={() => setHiddenAreas(hiddenAreas.filter(a => a != area.name))} type={'primary'} icon={<EyeInvisibleOutlined />} />}
                            </div>
                        )}
                    </AreaButtons>
                    <ActionsButton>
                        {currentAreaName && <Button style={{ background: '#388e3c', color: 'white' }} onClick={confirmArea} icon={<CheckOutlined />} />}
                        {currentAreaName && <Button style={{ background: '#e53935', color: 'white' }} onClick={cancelArea} icon={<CloseOutlined />} />}
                        {!currentAreaName &&
                            <Button onClick={() => setDeleteMode(!deleteMode)} type={deleteMode ? 'primary' : 'default'} icon={<DeleteOutlined />} />
                        }
                    </ActionsButton>

                </ButtonsContainer>
            </ImageToolbar>
        </Container>
    );

}